import * as types from '../actions/actionTypes';

let initialState={
    createApplication: {
        loading: false,
        success: true,
        message: '',
        id: 0,
        data: {},
    }
};

export default (state = initialState, action) => {
    switch(action.type) {
        case types.START_CREATE_APPLICATION:
            return {...state, createApplication: { ...state.createApplication, loading: true, id: 0 } };
        case types.CREATE_APPLICATION:
            return {...state, createApplication: { loading: false, success: action.response.success, message: action.response.message, id: action.response.id, data: action.response.data } };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CreateApplicationReducer.js